import { useTranslation } from 'react-i18next';

import { ReactComponent as AlertCheckmark } from '../../../../../../assets/icons/alert-circle.svg';
import { ReactComponent as SuccessCheckmark } from '../../../../../../assets/icons/check-circle.svg';
import { IPasswordValidations } from '../../../../../../shared/interfaces/auth';

import './PasswordValidations.scss';

const PasswordValidations = ({ validation, texts }: IPasswordValidations) => {
  const { t } = useTranslation();

  const displayIcon = (isValid: boolean) => {
    if (isValid) {
      return <SuccessCheckmark className="password-validations__icon" aria-hidden="true" focusable="false" />;
    }
    return <AlertCheckmark className="password-validations__icon" aria-hidden="true" focusable="false" />;
  };

  return (
    <div className="flex flex-col password-validations">
      <div className="text-left password-validations__description">{t(texts.description)}</div>
      <div className="flex flex-col password-validations__list">
        <div
          className={`password-validations__row ${validation.validLength ? 'password-validations__row--valid' : ''}`}
        >
          {displayIcon(validation.validLength)}
          <div className="password-validations__text">{t(texts.firstCondition)}</div>
        </div>
        <div
          className={`password-validations__row ${validation.lowerCase && validation.upperCase ? 'password-validations__row--valid' : ''}`}
        >
          {displayIcon(validation.lowerCase && validation.upperCase)}
          <div className="password-validations__text">{t(texts.secondCondition)}</div>
        </div>
        <div className={`password-validations__row ${validation.hasNumber ? 'password-validations__row--valid' : ''}`}>
          {displayIcon(validation.hasNumber)}
          <div className="password-validations__text">{t(texts.thirdCondition)}</div>
        </div>
      </div>
    </div>
  );
};

export default PasswordValidations;
